import * as React from "react";
// import ReactGA from "react-ga4";
import { useCookies } from "react-cookie";

export function useAnalytics() {
  const [initialized, setInitialized] = React.useState(false);
  const [cookies] = useCookies(["personalised"]);

  React.useEffect(() => {
    if (cookies.personalised && JSON.parse(cookies.personalised)) {
      // ReactGA.initialize('UA-136806100-1');
      // ReactGA.initialize('G-1PD00T8GCY');

      setInitialized(true);
    }
  }, [cookies]);
  return {
    initialized
  };
}
